import { AxisItemIdentifier } from "@mui/x-charts";
import React, { createContext, useContext, useMemo, useState, FunctionComponent } from "react";

interface ILinkedChartsContext {
  highlightedAxis?: AxisItemIdentifier[];
  updateHighlightedAxis: (payload: AxisItemIdentifier[]) => void;
};
const initContext = (): ILinkedChartsContext => ({
  updateHighlightedAxis: () => null
});

const LinkedChartsContext = createContext<ILinkedChartsContext | null>(null);

interface ILinkedChartsProps {
  children: React.ReactNode;
}
export const LinkedCharts: FunctionComponent<ILinkedChartsProps> = (props: ILinkedChartsProps) => {

  const { children } = props;

  const [state, setState] = useState<ILinkedChartsContext>(initContext());

  const value = useMemo<ILinkedChartsContext>(() => ({
    ...state,
    updateHighlightedAxis: (payload) => setState(s => ({ ...s, highlightedAxis: payload })),
  }), [state]);

  return <LinkedChartsContext.Provider value={value}>{children}</LinkedChartsContext.Provider>;
}

export const useLinkedCharts = () => useContext(LinkedChartsContext);
